import { Typography } from "@mui/material";
import React from "react";

interface CellTextProps {
  children: string;
  wrap?: boolean;
}

const CellText = ({ children, wrap = false }: CellTextProps) => {
  const text = children == null ? "" : String(children);

  if (wrap) {
    return (
      <Typography
        variant="body2"
        color="text.primary"
        component="span"
        sx={{
          display: "block",
          whiteSpace: "normal",
          wordBreak: "break-word",
          overflowWrap: "anywhere",
          width: "100%",
          lineHeight: 1.43,
        }}
      >
        {text}
      </Typography>
    );
  }

  return (
    <Typography
      variant="body2"
      color="text.primary"
      component="span"
      sx={{
        display: "inline-block",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        width: "100%",
        minWidth: 0,
      }}
    >
      {text}
    </Typography>
  );
};

export default CellText;
